module.exports = __webpack_public_path__ + "img/QuietComfortPro2.724cf9ac.svg";